import axios from 'axios';

const apiURL = process.env.REACT_APP_BASE_URL;
axios.defaults.baseURL = apiURL;
console.log('apiURL->>>', apiURL)
export default axios;
